
$(document).ready(function () {

  var SpeechRecognition =
    window.SpeechRecognition ||
    window.webkitSpeechRecognition;

  var recognition = null;
  var isListening = false;

  // Finalized speech segments from the current session.
  var sessionFinalText = "";

  // Existing transcript before the current session starts.
  var previousText = "";

  var $transcriptBox 	= $("#transcript");		// SPOKEN TEXT
  var $debugBox 		= $("#debug");			// SPOKEN TO DEBUG TEXT
  
  var $statusBox 		= $("#status");			// STATUS : READY / LISTENING
  var $orderRows 		= $("#orderRows");		// PART ORDER : TABLE BODY
  var $startBtn 		= $("#startBtn");		// START BUTTON
  var $stopBtn 			= $("#stopBtn");		// STOP BUTTON
  var $itemCount 		= $("#itemCount");		// ITEMS COUNT RECORD


  // Initialize speech recognition.
  if (SpeechRecognition) {

    recognition = new SpeechRecognition();

    recognition.lang 			= "en-IN";					// specify language
    recognition.continuous 		= true;						// continious speech
    recognition.interimResults 	= true;						// get interim result, when even is not final
    recognition.maxAlternatives = 1;

    recognition.onstart = function () {

      isListening = true;

      $startBtn.prop("disabled", true);
      $stopBtn.prop("disabled", false);

      $statusBox.text("Status: Listening...");

    };


    recognition.onresult = function (event) {

      var interimText = "";
      var debugText = "";

      for (var i = 0; i < event.results.length; i++) {

        var result = event.results[i];
        var spokenText = result[0].transcript;

        debugText +=
          (result.isFinal ? "FINAL: " : "INTERIM: ") +
          spokenText + "\n";

        if (result.isFinal) {

          // Append only newly finalized results.
          if (i >= event.resultIndex) {
            sessionFinalText += spokenText + " ";
          }

        } else {

          interimText += spokenText + " ";

        }
      }
	
      $transcriptBox.val(previousText + sessionFinalText +	interimText);

      $debugBox.val(debugText);

      // Scroll debug box to the bottom.
      $debugBox.scrollTop($debugBox[0].scrollHeight);

      // Parse finalized text only.
      renderOrder(previousText + sessionFinalText);

    };


    recognition.onerror = function (event) {

      $statusBox.text("Status: " + event.error);

    };


    recognition.onend = function () {

      isListening = false;

      $startBtn.prop("disabled", false);
      $stopBtn.prop("disabled", true);

      // Keep the complete transcript for the next session.
      previousText = $transcriptBox.val().trim();

      $statusBox.text("Status: Stopped");

      updateTable();

    };

  } else {

    $statusBox.text(
      "Speech recognition is not supported. Please use Chrome."
    );

    $startBtn.prop("disabled", true);

  }


  // Start listening.
  window.startListening = function () {

    if (!recognition || isListening) return;

    previousText = $transcriptBox.val().trim();
    sessionFinalText = "";

    try {

      recognition.start();

    } catch (error) {

      $statusBox.text("Could not start: " + error.message);

    }

  };


  // Stop listening.
  window.stopListening = function () {

    if (recognition && isListening) {
      recognition.stop();
    }

  };


  // Clear the order and transcript.
  window.clearOrder = function () {

    if (recognition && isListening) {
      recognition.stop();
    }

    $transcriptBox.val("");
    $debugBox.val("");

    previousText = "";
    sessionFinalText = "";

    $orderRows.empty();

    $("<tr>")
      .append(
        $("<td>", {
          colspan: 4,
          text: "No parts detected yet."
        })
      )
      .appendTo($orderRows);

    $itemCount.text("0 items");
    $statusBox.text("Status: Ready");

  };


  // Convert spoken number words to digits.
  function normalizeNumbers(text) {

    var numberWords = {
      zero: "0",
      oh: "0",
      one: "1",
      two: "2",
      three: "3",
      four: "4",
      five: "5",
      six: "6",
      seven: "7",
      eight: "8",
      nine: "9"
    };

    return text.replace(
      /\b(zero|oh|one|two|three|four|five|six|seven|eight|nine)\b/gi,
      function (word) {
        return numberWords[word.toLowerCase()];
      }
    );

  }


  // Parse finalized transcript into part numbers and quantities.
  function parseOrder(text) {

    text = normalizeNumbers(text);

    // "next part" marks the beginning of another item.
    var segments = text
      .split(/\bnext\s+part(?:\s+number)?\b/i)
      .map(function (segment) {
        return segment.trim();
      })
      .filter(function (segment) {
        return segment.length > 0;
      });

    var items = [];

    segments.forEach(function (segment) {

      var quantityMatch = segment.match(
        /\bquantity\s*[:=-]?\s*(\d+)\b/i
      );

      if (!quantityMatch) return;

      var quantity = quantityMatch[1];

      var partNumber = segment
        .slice(0, quantityMatch.index)
        .replace(/\bpart\s+number\b/i, "")
        .replace(/^\s*[:=-]\s*/, "")
        .trim();

      if (!partNumber) return;

      // Clean punctuation at the edges.
      partNumber = partNumber.replace(
        /^[,.\s]+|[,.\s]+$/g,
        ""
      );
	 //
	 partNumber = partNumber.replaceAll(" ","").toUpperCase();
	 
      items.push({
        partNumber: partNumber,
        quantity: quantity
      });

    });

    return items;

  }


  // Render parsed items into the table.
  function renderOrder(text) {

    var items = parseOrder(text);

    $orderRows.empty();

    if (items.length === 0) {

      $("<tr>")
        .append(
          $("<td>", {
            colspan: 4,
            text: "No complete part/quantity pairs detected."
          })
        )
        .appendTo($orderRows);

      $itemCount.text("0 items");

      return;

    }

    items.forEach(function (item, index) {

      addRow(
        item.partNumber,
        item.quantity,
        index + 1
      );

    });

    $itemCount.text(
      items.length +
      (items.length === 1 ? " item" : " items")
    );

  }


  // Add one editable table row.
  function addRow(partNumber, quantity, rowNumber) {

    var $tr = $("<tr>");

    var $numberCell = $("<td>").text(rowNumber);

    var $partInput = $("<input>", {
      type: "text",
      class: "part-number"
    }).val(partNumber);

    var $partCell = $("<td>").append($partInput);


    var $quantityInput = $("<input>", {
      type: "number",
      min: 1,
      step: 1,
      class: "quantity"
    }).val(quantity);

    var $quantityCell = $("<td>").append($quantityInput);


    var $removeButton = $("<button>", {
      type: "button",
      class: "remove",
      text: "Remove"
    });

    var $actionCell = $("<td>").append($removeButton);


    $tr.append(
      $numberCell,
      $partCell,
      $quantityCell,
      $actionCell
    );

    $orderRows.prepend($tr);

  }


  // Handle dynamically generated Remove buttons.
  // Event delegation works for rows added later.
  $orderRows.on("click", ".remove", function () {

    $(this).closest("tr").remove();

    renumberRows();

  });


  // Renumber rows and update item count.
  function renumberRows() {

    var $rows = $orderRows.find("tr");

    $rows.each(function (index) {

      var $row = $(this);

      if ($row.children("td").length === 4) {
        $row.children("td").first().text(index + 1);
      }

    });

    var count = $orderRows.find("input.part-number").length;

    $itemCount.text(
      count + (count === 1 ? " item" : " items")
    );

  }


  // Refresh the table using the transcript.
  function updateTable() {

    renderOrder($transcriptBox.val());

  }
  
  window.updateTable = function () {
    renderOrder($transcriptBox.val());
  };


});

